import { Box, Flex, Input, Text } from '@chakra-ui/react';
import { KeyboardEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePlanPageRevampVariant } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/usePlanPageUiRevamp';
import {
  PLAN_PROPERTY_CARD_SHADOW,
  PLAN_PROPERTY_CARD_WIDTH,
} from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planInputPanelTheme';
import { PLAN_FONT } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/planPageRevampTypography';
import { getShowNewGroupInput, setShowNewGroupInput } from 'redux/ItemPageSlice';
import { getSelectedDriver } from 'redux/PlanPageSlice';
import PlanPermission from 'container/PlanPermission';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

import Plus from '../../../../components/Icons/Plus';

interface NewGroupProperties {
  setAddGroupName: (argument: string | null) => void;
  addGroup: (event: any) => void;
  addGroupName: string | null;
  planPermission: boolean;
  variant?: 'legacy' | 'revamp';
}

const NewGroup = ({
  setAddGroupName,
  addGroup,
  planPermission,
  addGroupName,
  variant = 'legacy',
}: NewGroupProperties) => {
  const dispatch: AppDispatch = useDispatch();
  const isRevamp = usePlanPageRevampVariant(variant);
  const themeColors = useSelector(getPlanPageThemeColors);

  const showNewGroupInput = useSelector(getShowNewGroupInput);
  const currentDriver = useSelector(getSelectedDriver);

  const changeInputHandler = (event: any) => {
    setAddGroupName(event.target.value);
  };

  const OnKeyEnter = async (event: any) => {
    if (event && event.code === 'Enter' && event.target?.value.trim().length > 0) {
      addGroup(event);
    }
    return null;
  };

  const AddGroupNameOnBlur = async (event: any) => {
    if (addGroupName && event.target?.value.trim().length > 1) {
      addGroup(event);
    } else {
      dispatch(setShowNewGroupInput(false));
    }
  };

  if (showNewGroupInput) {
    return (
      <Flex
        justifyContent='center'
        alignItems='center'
        pb={isRevamp ? 0 : '15px'}
        mb={isRevamp ? '20px' : undefined}
        cursor='pointer'
        w={isRevamp ? PLAN_PROPERTY_CARD_WIDTH : undefined}
        minW={isRevamp ? PLAN_PROPERTY_CARD_WIDTH : undefined}
        flexShrink={0}
      >
        <Input
          fontFamily={isRevamp ? PLAN_FONT.comfortaaBold : undefined}
          fontSize={isRevamp ? '14px' : undefined}
          fontWeight={isRevamp ? 700 : undefined}
          style={{
            border: isRevamp ? `1px solid ${themeColors.border}` : '1px solid #4bb6b9',
            boxShadow: 'none',
          }}
          _placeholder={{ color: themeColors.textSecondary }}
          placeholder='New Group'
          onChange={(event: any) => changeInputHandler(event)}
          onKeyDown={(event: KeyboardEvent) => OnKeyEnter(event)}
          onBlur={(event: any) => AddGroupNameOnBlur(event)}
          autoFocus
        />
      </Flex>
    );
  }

  if (isRevamp) {
    return (
      <Flex
        alignItems='center'
        justifyContent='center'
        gap={2}
        mr={0}
        mb={0}
        minW={PLAN_PROPERTY_CARD_WIDTH}
        w={PLAN_PROPERTY_CARD_WIDTH}
        minH='120px'
        p={3}
        flexShrink={0}
        border='1px dashed'
        borderColor='#BEBEBE'
        borderRadius='12px'
        bg={themeColors.surface}
        boxShadow={PLAN_PROPERTY_CARD_SHADOW}
        cursor={planPermission ? 'not-allowed' : 'pointer'}
        onClick={planPermission ? undefined : () => dispatch(setShowNewGroupInput(true))}
      >
        <Plus height={4} width={4} />
        <Text
          fontSize='16px'
          fontWeight='700'
          fontFamily={PLAN_FONT.comfortaaBold}
          color={themeColors.textDark}
        >
          {currentDriver?.group_property}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      justifyContent='center'
      alignItems='center'
      pb='15px'
      cursor={planPermission ? 'not-allowed' : 'pointer'}
      onClick={planPermission ? undefined : () => dispatch(setShowNewGroupInput(true))}
    >
      <Box mr='15px'>
        <Plus height={5} width={5} />
      </Box>
      <Text fontSize='1xl' pt='2px'>
        {currentDriver?.group_property}
      </Text>
    </Flex>
  );
};

export default PlanPermission(NewGroup);
